'use client'

import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { TrustBadgesDSWidget } from './trust-badges-ds-widget'
import { TrustBadgesWidgetLegacy } from './trust-badges-widget-legacy'

import type { TrustBadgesWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

// Router: DS branch when the Design System gate is active, else the legacy widget.
const TrustBadgesWidgetComponent = (props: PLTypedWidgetProps<TrustBadgesWidgetData>) => {
  if (shouldUseDesignSystem()) {
    return <TrustBadgesDSWidget {...props} />
  }
  return <TrustBadgesWidgetLegacy {...props} />
}

export const TrustBadgesWidget: PLTypedWidgetInterface<TrustBadgesWidgetData, WidgetType.TRUST_BADGES> = {
  id: WidgetType.TRUST_BADGES,
  errorBoundary: PLBaseErrorBoundary,
  render: TrustBadgesWidgetComponent,
}
